<template>
  <div class="h5 info-alert">
    <p v-if="environment" class="mb-0">{{ environment }}</p>
    <p class="mb-0">Accepted:
      <span :class="{'custom-text-danger font-weight-bold': assignedMoreThanAllowedForAccepted(value)}"
            :title="assignedMoreThanAllowedForAccepted(value) ? 'Granted too many shifts!' : ''">
              {{ value.counter }}</span>/{{ totalShifts(value) }}
    </p>
    <p v-if="!isManagementEvaluation" class="mb-3">Waiting list:
      <span :class="{'custom-text-danger font-weight-bold': assignedMoreThanAllowedForReserve(value)}"
            :title="assignedMoreThanAllowedForReserve(value) ? 'Granted too many shifts!' : ''">
              {{ value.counterReserve }}</span>/{{ totalShiftsReserve(value) }}
    </p>
    <p v-else class="mb-3">Waiting list granted: <span>{{ value.counterReserve }}</span></p>

    <p v-for="(data, station) in value.end_stations"
       :key="station"
       class="mb-3">
      <span class="d-block">{{ station.replace(' microscope', '') }}</span>
      <span class="d-block">Accepted: {{ data.shifts }}/{{ totalShifts(value) }}</span>
      <span v-if="!isManagementEvaluation">
              Waiting list: {{ data.shiftsReserve }}/{{ totalShiftsReserve(value) }}
            </span>
      <span v-else>Waiting list granted: {{ data.shiftsReserve }}</span>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'ShiftsCounterViewSingle',
    props: {
      isManagementEvaluation: {
        type: Boolean,
        required: true,
      },
      value: {
        type: Object,
        required: true,
      },
      environment: {
        type: String,
        default: '',
      },
    },
    methods: {
      assignedMoreThanAllowedForAccepted(value) {
        const shifts = this.isManagementEvaluation ? value.shifts + value.shiftsManagement : value.shifts;
        return shifts !== 0 && (shifts - value.counter) < 0;
      },
      assignedMoreThanAllowedForReserve(value) {
        return value.shiftsReserve !== 0 && (value.shiftsReserve - value.counterReserve) < 0;
      },
      totalShifts(value) {
        const totalShiftsNumber = this.isManagementEvaluation ? value.shifts + value.shiftsManagement : value.shifts;
        return totalShiftsNumber !== '' ? totalShiftsNumber : 'No data';
      },
      totalShiftsReserve(value) {
        return value.shiftsReserve !== '' ? value.shiftsReserve : 'No data';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .info-alert {
    color: $color-blue-info !important;
  }
</style>
